import React /* , { useState } */ from "react";

import PropTypes from "prop-types";
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";

import FloatLabel from "./FloatingLabel";
import "./styles.scss";

const Component = ({ placeholder, ...props }) => {
  return (
    <FloatLabel
      className="container--input"
      label={placeholder}
      labelLeft={"label--left"}
      value={props.selected}>
      <DatePicker className="datePicker" dateFormat="dd/MM/yyyy" {...props} />
    </FloatLabel>
  );
};

Component.propTypes = {
  placeholder: PropTypes.string,
  selected: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

Component.defaultProps = {};

export default Component;
